import Vue from 'vue'
import configs from '@/config'

let resource = null

const actions = {
  list: {
    method: 'GET',
    url: `${configs.baseUrl}/api/custom-fonts`,
  },
  upload: {
    method: 'POST',
    url: `${configs.baseUrl}/api/custom-fonts`,
  },
  remove: {
    method: 'DELETE',
    url: `${configs.baseUrl}/api/custom-fonts/{token}`,
  },
}

const initResource = () => {
  resource = Vue.resource('', {}, actions)
}

const list = () => resource.list()

const upload = ({ file, rightsConfirmed, onProgress }) => {
  const body = new FormData()
  body.append('file', file)
  body.append('rightsConfirmed', rightsConfirmed ? 'true' : 'false')
  const options = onProgress ?
    {
      uploadProgress: (event) => {
        if (event.lengthComputable) onProgress(Math.round((event.loaded / event.total) * 100))
      },
    } :
    {}
  return Vue.http.post(actions.upload.url, body, options)
}

const remove = (token) => resource.remove({ token })

const resolve = async (token) => {
  const response = await fetch(`${configs.baseUrl}/api/custom-fonts/public/${token}`, {
    credentials: 'omit',
  })
  if (!response.ok) return null
  return response.json()
}

const errorCodeOf = (error) => {
  const body = error && (error.body || error.data)
  if (body && body.code) return body.code
  // The shared guardByPlanBenefit middleware answers a missing plan benefit with a code-less 403.
  return error && error.status === 403 ? 'FONT_PLAN_REQUIRED' : null
}

export default {
  initResource,
  list,
  upload,
  remove,
  resolve,
  errorCodeOf,
}
